/**
 * Created by piotr.pozniak@thebeaverhead.com on 28/05/2025.
 */

import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import * as usersActions from "../../actions/users";

export function useUsersStore() {
  const dispatch = useDispatch();
  const _users = useSelector((store) => store.users);

  const fetchUsers = useCallback(
    async (page, ipp, name, email, sort, direction) =>
      await dispatch(
        usersActions.fetchUsers(page, ipp, name, email, sort, direction)
      ),
    [dispatch]
  );
  const deleteUser = useCallback(
    async (uuid) => await dispatch(usersActions.deleteUser(uuid)),
    [dispatch]
  );

  const activateAccount = useCallback(
    async (uuid) => await dispatch(usersActions.activateAccount(uuid)),
    [dispatch]
  );

  return {
    users: _users,
    fetchUsers,
    deleteUser,
    activateAccount,
  };
}
